module.exports = __webpack_public_path__ + "img/azul.c78c0d27.png";